<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="助理姓名">
              <a-input placeholder="请输入助理姓名" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="助理手机号">
              <a-input placeholder="请输入助理手机号" v-model="queryParam.mobile"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="医生姓名">
              <a-input placeholder="请输入医生姓名" v-model="queryParam.doctorName"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('doctor_assistant_relation')">导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <span style="float:right;">
          <a @click="loadData()"><a-icon type="sync" />刷新</a>
        </span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
               <a @click="handleDoctorAssistan(record)">服务医生</a>
        </span>
      </a-table>
    </div>


    <doctor-assistant-modal ref="doctorAssistantModal" ></doctor-assistant-modal>

    <doctor-assistant-relation-modal ref="modalForm" @ok="modalFormOk"></doctor-assistant-relation-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import '@assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DoctorAssistantRelationModal from './DoctorAssistantRelationModal'
  import DoctorAssistantModal from './modules/DoctorAssistantModal'




  export default {
    name: 'DoctorAssistantRelationList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DoctorAssistantRelationModal,
      DoctorAssistantModal,

    },
    data () {
      return {
        description: 'doctor_assistant_relation管理页面',
        modalVisible:false,
        id:'',
        doctorId:'',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'助理姓名',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'助理手机号',
            align:"center",
            dataIndex: 'mobile'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/doctor/doctorAssistantRelation/list",
          delete: "/doctor/doctorAssistantRelation/delete",
          deleteBatch: "/doctor/doctorAssistantRelation/deleteBatch",
          exportXlsUrl: "/doctor/doctorAssistantRelation/exportXls",
          importExcelUrl: "doctor/doctorAssistantRelation/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      serviceDoctor(record){
        let id =record.id;
        this.$router.push({
          name: '/doctorList',
          path: '/doctorList',
          params: {
            id: id
          }
        })
      },

      handleDoctorAssistan(record){

        this.$refs.doctorAssistantModal.showAssistan(record);

      },

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>